import { FormControlLabel, Radio, type RadioProps, styled } from '@mui/material'
import { CircleIcon, RadioButtonIcon } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { Typography } from '../../text'

type RadioButtonProps = Pick<RadioProps, 'value' | 'name' | 'checked' | 'onChange' | 'disabled'> & {
    label: string
    size?: 'small' | 'medium'
}

export function RadioButton({ label, disabled, size = 'medium', ...props }: RadioButtonProps) {
    const isSmall = size === 'small'
    const iconSize = isSmall ? tokens.SizingIconS : tokens.SizingIconM
    return (
        <FormControlLabel
            disabled={disabled}
            sx={{ margin: 0, gap: tokens.SizingSpacing100 }}
            label={
                <Typography
                    variant={isSmall ? 'textS' : 'textM'}
                    color={disabled ? tokens.ColorTextDisabled : isSmall ? tokens.ColorTextDefault : tokens.ColorTextBold}
                >
                    {label}
                </Typography>
            }
            control={
                <StyledRadio
                    {...props}
                    disabled={disabled}
                    disableRipple
                    icon={<CircleIcon size={iconSize} />}
                    checkedIcon={<RadioButtonIcon size={iconSize} weight="fill" />}
                />
            }
        />
    )
}

const StyledRadio = styled(Radio)({
    padding: 0,
    color: tokens.ColorIconDefault,
    '&.Mui-checked': { color: tokens.ColorIconLinkSelected },
    '&:hover:not(.Mui-disabled)': { color: tokens.ColorIconLinkHover },
    '&.Mui-disabled': { color: tokens.ColorIconDisabled },
})
